import { render, staticRenderFns } from "./FeedGood.vue?vue&type=template&id=16411dfa&scoped=true"
import script from "./FeedGood.vue?vue&type=script&lang=js"
export * from "./FeedGood.vue?vue&type=script&lang=js"
import style0 from "./FeedGood.vue?vue&type=style&index=0&id=16411dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16411dfa",
  null
  
)

export default component.exports